import api from "kw/api";
import { deref } from "kanopi-components/utils/primitives";

type TUsePasswordResetRequestArgs = {
  email?: string;
};

export function usePasswordResetRequest(
  { email }: TUsePasswordResetRequestArgs = { email: "" }
) {
  async function passwordResetRequest(overrides = {}) {
    await sendPasswordResetRequest(deref(overrides, "email", email));
  }

  return passwordResetRequest;
}

export async function sendPasswordResetRequest(email) {
  return api.mutation({
    sendPasswordResetEmail: [
      {
        email,
      },
      {
        success: true,
        errors: true,
      },
    ],
  });
}
